const menu = [
  {
    id: 0,
    title: "사업소개",
    submenu1: "주차장 소개",
    submenu2: "담당부서 안내",
    subMenu3: "",
  },
  {
    id: 1,
    title: "이용안내",
    submenu1: "주차요금 안내",
    submenu11: "요금안내",
    submenu12: "미납주차 요금안내",
    submenu2: "시설 현황",
    submenu21: "노상주차장 현황",
    submenu22: "노외주차장 현황",
    submenu23: "학교주차장 현황",
    submenu3: "정기권 신청",
    submenu4: "시간권 구매",
    submenu5: "주차장 안내",
    submenu6: "할인안내",
  },
  {
    id: 2,
    title: "주차정보",
    submenu1: "실시간 주차정보",
    submenu2: "미납정보 조회",
  },
  {
    id: 3,
    title: "고객지원",
    submenu1: "공지 사항",
    submenu2: "자주하는 질문",
    submenu3: "차량변경/환불요청",
  },
  {
    id: 4,
    title: "마이페이지",
    submenu1: "차량 등록 현황",
    submenu2: "정기권 등록 현황",
    submenu21: "정기권 사용 내역",
    submenu22: "정기권 신청 내역",
    submenu23: '차량등록/환불요청',
    submenu3: "시간권 구매 현황",
    submenu4: "회원정보 수정",
    submenu5: "회원 탈퇴",
  },
];

export default menu